import '../application';

$(document).ready(() => {
  // Back-to-top link click event.
  $('main .top-link > a').click(() => {
    $([document.documentElement, document.body]).animate({
      scrollTop: 0
    }, 200);

    return false;
  });

  // Window scroll event
  window.onscroll = () => {
    toggleTopLink();
  };

  toggleTopLink();
});

/**
 * Show or hide back-to-top link.
 */
function toggleTopLink () {
  if (
    (document.body.scrollTop > 2 || document.documentElement.scrollTop > 2) &&
    Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) > 599 // 599 Matches the show/hide CSS min-width media query breakpoint set at 600px.
  ) {
    $('main .top-link').show();
  } else {
    $('main .top-link').hide();
  }
}
